// extracted by mini-css-extract-plugin
export default {"activityFeed":"activity_activityFeed__-TLN1","card":"activity_card__GRakx","feedItem":"activity_feedItem__NiMY1","item1":"activity_item1__V8VTt","item2":"activity_item2__Gklk6"};